module.exports = __webpack_public_path__ + "img/vikingshield_resized.fea58d77.png";